import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import Accordion, { AccordionItem } from '../components/ui/Accordion';
import { UsersIcon, CalendarIcon, MailIcon, PhoneIcon, ClipboardCheckIcon, HandIcon, HeartIcon, BriefcaseIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const PTA = () => {
  return <div className="min-h-screen bg-white" data-id="element-4581">
      <PageHeader title="Parent-Teacher Association" description="The PTA serves as a vital link between parents and the school, working together to enhance the educational experience of our students." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'PTA',
      path: '/pta'
    }]} data-id="element-4582" />
      <div className="container mx-auto px-4 py-12" data-id="element-4583">
        {/* Introduction Section */}
        <section className="mb-16" data-id="element-4584">
          <div className="text-center mb-10" data-id="element-4585">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-4586">
              Welcome to the IGS Parent-Teacher Association
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-4587"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-4588">
              Working together to create a supportive environment for our
              students' academic and personal growth.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-4589">
            <div data-id="element-4590">
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-4591">
                The Parent-Teacher Association (PTA) of Isonyin Grammar School
                is a collaborative body of parents, guardians, and teachers
                dedicated to enhancing the educational experience of our
                students. We believe that when parents and teachers work
                together, students benefit tremendously.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-4592">
                Our PTA serves as a vital communication channel between the home
                and school, ensuring that parents are informed about school
                activities and policies, while also providing a platform for
                parents to contribute to the school's development.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-4593">
                Through regular meetings, events, and volunteer opportunities,
                the PTA fosters a sense of community and shared responsibility
                for the education and welfare of our students. We invite all
                parents and guardians to actively participate in the PTA and
                contribute to making Isonyin Grammar School an even better place
                for our children.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-4594">
              <div className="bg-blue-50 p-6 rounded-lg hover:shadow-md transition-shadow" data-id="element-4595">
                <div className="flex items-center mb-3" data-id="element-4596">
                  <UsersIcon className="h-6 w-6 text-blue-700 mr-2" data-id="element-4597" />
                  <h3 className="font-bold text-blue-900" data-id="element-4598">
                    Community Building
                  </h3>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-4599">
                  Creating a strong network of parents, teachers, and
                  administrators
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg hover:shadow-md transition-shadow" data-id="element-4600">
                <div className="flex items-center mb-3" data-id="element-4601">
                  <ClipboardCheckIcon className="h-6 w-6 text-blue-700 mr-2" data-id="element-4602" />
                  <h3 className="font-bold text-blue-900" data-id="element-4603">Academic Support</h3>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-4604">
                  Enhancing educational experiences through resources and
                  programs
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg hover:shadow-md transition-shadow" data-id="element-4605">
                <div className="flex items-center mb-3" data-id="element-4606">
                  <HandIcon className="h-6 w-6 text-blue-700 mr-2" data-id="element-4607" />
                  <h3 className="font-bold text-blue-900" data-id="element-4608">
                    Volunteer Services
                  </h3>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-4609">
                  Organizing volunteers for school events and activities
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg hover:shadow-md transition-shadow" data-id="element-4610">
                <div className="flex items-center mb-3" data-id="element-4611">
                  <HeartIcon className="h-6 w-6 text-blue-700 mr-2" data-id="element-4612" />
                  <h3 className="font-bold text-blue-900" data-id="element-4613">Student Welfare</h3>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-4614">
                  Promoting the well-being and safety of all students
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* PTA Leadership Section */}
        <section className="mb-16" data-id="element-4615">
          <div className="text-center mb-10" data-id="element-4616">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-4617">
              PTA Leadership
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-4618"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-4619">
              Meet the dedicated parents and teachers who lead our PTA.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-4620">
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-4621">
              <div className="w-full h-56 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center" data-id="element-4622">
                <UsersIcon className="h-24 w-24 text-blue-700" data-id="element-4623" />
              </div>
              <div className="p-6" data-id="element-4624">
                <h3 className="text-xl font-bold text-blue-900" data-id="element-4625">
                  Mrs. Abimbola Olatunji
                </h3>
                <p className="text-blue-700 mb-3" data-id="element-4626">PTA Chairperson</p>
                <p className="text-gray-700 mb-4" data-id="element-4627">
                  A dedicated parent with three children at IGS. Mrs. Olatunji
                  has been actively involved in the PTA for 5 years and is
                  committed to strengthening the partnership between parents and
                  the school.
                </p>
                <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-4628">
                  <MailIcon className="h-4 w-4 mr-2" data-id="element-4629" />
                  <span data-id="element-4630">pta.chair@isonyingrammarschool.edu.ng</span>
                </div>
                <div className="flex items-center text-gray-600 text-sm" data-id="element-4631">
                  <PhoneIcon className="h-4 w-4 mr-2" data-id="element-4632" />
                  <span data-id="element-4633">+234 (0) 803 456 7890</span>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-4634">
              <div className="w-full h-56 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center" data-id="element-4635">
                <UsersIcon className="h-24 w-24 text-blue-700" data-id="element-4636" />
              </div>
              <div className="p-6" data-id="element-4637">
                <h3 className="text-xl font-bold text-blue-900" data-id="element-4638">
                  Mr. Emmanuel Adeyemi
                </h3>
                <p className="text-blue-700 mb-3" data-id="element-4639">PTA Vice Chairperson</p>
                <p className="text-gray-700 mb-4" data-id="element-4640">
                  A parent of two IGS students and a business executive. Mr.
                  Adeyemi brings his organizational skills and leadership
                  experience to support the PTA's initiatives.
                </p>
                <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-4641">
                  <MailIcon className="h-4 w-4 mr-2" data-id="element-4642" />
                  <span data-id="element-4643">pta.vicechair@isonyingrammarschool.edu.ng</span>
                </div>
                <div className="flex items-center text-gray-600 text-sm" data-id="element-4644">
                  <PhoneIcon className="h-4 w-4 mr-2" data-id="element-4645" />
                  <span data-id="element-4646">+234 (0) 805 678 9012</span>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-4647">
              <div className="w-full h-56 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center" data-id="element-4648">
                <UsersIcon className="h-24 w-24 text-blue-700" data-id="element-4649" />
              </div>
              <div className="p-6" data-id="element-4650">
                <h3 className="text-xl font-bold text-blue-900" data-id="element-4651">
                  Mrs. Chioma Nwosu
                </h3>
                <p className="text-blue-700 mb-3" data-id="element-4652">PTA Secretary</p>
                <p className="text-gray-700 mb-4" data-id="element-4653">
                  A teacher at IGS and parent of a former student. Mrs. Nwosu
                  provides valuable insights from both the parent and teacher
                  perspectives, helping to bridge communication gaps.
                </p>
                <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-4654">
                  <MailIcon className="h-4 w-4 mr-2" data-id="element-4655" />
                  <span data-id="element-4656">pta.secretary@isonyingrammarschool.edu.ng</span>
                </div>
                <div className="flex items-center text-gray-600 text-sm" data-id="element-4657">
                  <PhoneIcon className="h-4 w-4 mr-2" data-id="element-4658" />
                  <span data-id="element-4659">+234 (0) 807 890 1234</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-blue-50 p-8 rounded-lg border border-blue-100" data-id="element-4660">
            <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-4661">
              Executive Committee
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4662">
              <div data-id="element-4663">
                <h4 className="font-bold text-blue-900 mb-3" data-id="element-4664">
                  Parent Representatives
                </h4>
                <ul className="space-y-3" data-id="element-4665">
                  <li className="flex items-start" data-id="element-4666">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-4667" />
                    <div data-id="element-4668">
                      <p className="font-bold" data-id="element-4669">Dr. Oluwasegun Adeyemi</p>
                      <p className="text-sm text-gray-600" data-id="element-4670">
                        JSS Representative
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-4671">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-4672" />
                    <div data-id="element-4673">
                      <p className="font-bold" data-id="element-4674">Mrs. Folake Ogunleye</p>
                      <p className="text-sm text-gray-600" data-id="element-4675">
                        SSS Representative
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-4676">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-4677" />
                    <div data-id="element-4678">
                      <p className="font-bold" data-id="element-4679">Mr. Taiwo Adesina</p>
                      <p className="text-sm text-gray-600" data-id="element-4680">
                        Boarding House Representative
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-4681">
                    <BriefcaseIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-4682" />
                    <div data-id="element-4683">
                      <p className="font-bold" data-id="element-4684">Mrs. Victoria Olatunji</p>
                      <p className="text-sm text-gray-600" data-id="element-4685">Treasurer</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div data-id="element-4686">
                <h4 className="font-bold text-blue-900 mb-3" data-id="element-4687">
                  School Representatives
                </h4>
                <ul className="space-y-3" data-id="element-4688">
                  <li className="flex items-start" data-id="element-4689">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-4690" />
                    <div data-id="element-4691">
                      <p className="font-bold" data-id="element-4692">Dr. Oluwasegun Adeyemi</p>
                      <p className="text-sm text-gray-600" data-id="element-4693">Principal</p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-4694">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-4695" />
                    <div data-id="element-4696">
                      <p className="font-bold" data-id="element-4697">Mrs. Folake Ogunleye</p>
                      <p className="text-sm text-gray-600" data-id="element-4698">
                        Vice Principal (Academics)
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-4699">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-4700" />
                    <div data-id="element-4701">
                      <p className="font-bold" data-id="element-4702">Mr. Oluwaseyi Johnson</p>
                      <p className="text-sm text-gray-600" data-id="element-4703">
                        Teacher Representative (JSS)
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-4704">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-4705" />
                    <div data-id="element-4706">
                      <p className="font-bold" data-id="element-4707">Ms. Abiola Oladipo</p>
                      <p className="text-sm text-gray-600" data-id="element-4708">
                        Teacher Representative (SSS)
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* PTA Initiatives Section */}
        <section className="mb-16" data-id="element-4709">
          <div className="text-center mb-10" data-id="element-4710">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-4711">
              PTA Initiatives & Achievements
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-4712"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-4713">
              Discover the various ways our PTA contributes to the school
              community.
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-4714">
            <div data-id="element-4715">
              <h3 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-4716">
                Recent Achievements
              </h3>
              <div className="space-y-6" data-id="element-4717">
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-4718">
                  <div className="flex items-center mb-3" data-id="element-4719">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4720">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-4721" />
                    </svg>
                    <h4 className="text-lg font-bold text-blue-900" data-id="element-4722">
                      Computer Lab Renovation
                    </h4>
                  </div>
                  <p className="text-gray-700 mb-2" data-id="element-4723">
                    The PTA successfully raised funds to renovate and upgrade
                    the school's computer laboratory, providing 25 new computers
                    and modern furniture.
                  </p>
                  <div className="text-sm text-gray-600" data-id="element-4724">
                    <span className="font-medium" data-id="element-4725">Completed:</span> August 2022
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-4726">
                  <div className="flex items-center mb-3" data-id="element-4727">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4728">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-4729" />
                    </svg>
                    <h4 className="text-lg font-bold text-blue-900" data-id="element-4730">
                      Scholarship Program
                    </h4>
                  </div>
                  <p className="text-gray-700 mb-2" data-id="element-4731">
                    Established a scholarship fund that currently supports 10
                    academically gifted students from financially disadvantaged
                    backgrounds.
                  </p>
                  <div className="text-sm text-gray-600" data-id="element-4732">
                    <span className="font-medium" data-id="element-4733">Launched:</span> January 2022
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-4734">
                  <div className="flex items-center mb-3" data-id="element-4735">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4736">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-4737" />
                    </svg>
                    <h4 className="text-lg font-bold text-blue-900" data-id="element-4738">
                      Teacher Appreciation Program
                    </h4>
                  </div>
                  <p className="text-gray-700 mb-2" data-id="element-4739">
                    Initiated an annual Teacher Appreciation Week with special
                    events and awards to recognize the dedication and hard work
                    of our teaching staff.
                  </p>
                  <div className="text-sm text-gray-600" data-id="element-4740">
                    <span className="font-medium" data-id="element-4741">Annual Event:</span> First
                    week of October
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-4742">
                  <div className="flex items-center mb-3" data-id="element-4743">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4744">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-4745" />
                    </svg>
                    <h4 className="text-lg font-bold text-blue-900" data-id="element-4746">
                      Library Enhancement
                    </h4>
                  </div>
                  <p className="text-gray-700 mb-2" data-id="element-4747">
                    Organized a book drive that collected over 1,000 books to
                    expand the school library's collection, particularly in the
                    areas of science, technology, and literature.
                  </p>
                  <div className="text-sm text-gray-600" data-id="element-4748">
                    <span className="font-medium" data-id="element-4749">Completed:</span> March 2023
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-4750">
              <h3 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-4751">
                Ongoing Initiatives
              </h3>
              <div className="bg-blue-900 text-white p-6 rounded-lg mb-6" data-id="element-4752">
                <h4 className="text-xl font-bold mb-4" data-id="element-4753">
                  Infrastructure Development Project
                </h4>
                <p className="mb-4" data-id="element-4754">
                  The PTA is currently fundraising for several infrastructure
                  improvements:
                </p>
                <ul className="space-y-3" data-id="element-4755">
                  <li className="flex items-start" data-id="element-4756">
                    <div className="h-5 w-5 text-yellow-400 mr-2" data-id="element-4757">✓</div>
                    <p data-id="element-4758">
                      Construction of a covered walkway between academic blocks
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-4759">
                    <div className="h-5 w-5 text-yellow-400 mr-2" data-id="element-4760">✓</div>
                    <p data-id="element-4761">
                      Renovation of the school auditorium with modern
                      audiovisual equipment
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-4762">
                    <div className="h-5 w-5 text-yellow-400 mr-2" data-id="element-4763">✓</div>
                    <p data-id="element-4764">
                      Installation of solar panels to provide alternative power
                      supply
                    </p>
                  </li>
                </ul>
                <div className="mt-4" data-id="element-4765">
                  <p className="mb-2" data-id="element-4766">Fundraising Progress:</p>
                  <div className="w-full bg-blue-800 rounded-full h-4" data-id="element-4767">
                    <div className="bg-yellow-500 h-4 rounded-full" style={{
                    width: '65%'
                  }} data-id="element-4768"></div>
                  </div>
                  <div className="flex justify-between text-sm mt-1" data-id="element-4769">
                    <span data-id="element-4770">₦6.5M raised</span>
                    <span data-id="element-4771">₦10M goal</span>
                  </div>
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-4772">
                <h4 className="text-xl font-bold text-blue-900 mb-4" data-id="element-4773">
                  Academic Support Programs
                </h4>
                <ul className="space-y-3" data-id="element-4774">
                  <li className="flex items-start" data-id="element-4775">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-4776">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-4777">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-4778" />
                      </svg>
                    </div>
                    <div data-id="element-4779">
                      <p className="font-bold" data-id="element-4780">After-School Tutoring</p>
                      <p className="text-sm text-gray-700" data-id="element-4781">
                        Volunteer parents and teachers provide additional
                        academic support in core subjects
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-4782">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-4783">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-4784">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-4785" />
                      </svg>
                    </div>
                    <div data-id="element-4786">
                      <p className="font-bold" data-id="element-4787">Career Mentorship</p>
                      <p className="text-sm text-gray-700" data-id="element-4788">
                        Connecting students with professionals in various fields
                        for guidance and inspiration
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-4789">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-4790">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-4791">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-4792" />
                      </svg>
                    </div>
                    <div data-id="element-4793">
                      <p className="font-bold" data-id="element-4794">Educational Workshops</p>
                      <p className="text-sm text-gray-700" data-id="element-4795">
                        Organizing workshops on study skills, exam preparation,
                        and digital literacy
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-100" data-id="element-4796">
                <div className="flex items-center mb-4" data-id="element-4797">
                  <CalendarIcon className="h-6 w-6 text-yellow-600 mr-3" data-id="element-4798" />
                  <h4 className="text-lg font-bold text-blue-900" data-id="element-4799">
                    Upcoming PTA Project
                  </h4>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-4800">
                  The PTA is planning to establish a Student Wellness Center
                  that will provide:
                </p>
                <ul className="space-y-2 text-gray-700" data-id="element-4801">
                  <li className="flex items-center" data-id="element-4802">
                    <div className="h-2 w-2 bg-yellow-500 rounded-full mr-2" data-id="element-4803"></div>
                    <span data-id="element-4804">
                      Counseling services for academic and personal issues
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-4805">
                    <div className="h-2 w-2 bg-yellow-500 rounded-full mr-2" data-id="element-4806"></div>
                    <span data-id="element-4807">Health education programs</span>
                  </li>
                  <li className="flex items-center" data-id="element-4808">
                    <div className="h-2 w-2 bg-yellow-500 rounded-full mr-2" data-id="element-4809"></div>
                    <span data-id="element-4810">Stress management and mental health support</span>
                  </li>
                </ul>
                <div className="mt-4 text-sm text-gray-600" data-id="element-4811">
                  <span className="font-medium" data-id="element-4812">Target Launch:</span> January
                  2024
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Meetings & Events Section */}
        <section className="mb-16" data-id="element-4813">
          <div className="text-center mb-10" data-id="element-4814">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-4815">
              Meetings & Events
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-4816"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-4817">
              Stay informed about upcoming PTA meetings and events.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4818">
            <div data-id="element-4819">
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-4820">
                Regular Meetings
              </h3>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-4821">
                <p className="text-gray-700 mb-4" data-id="element-4822">
                  The PTA holds regular general meetings throughout the academic
                  year. All parents, guardians, and teachers are encouraged to
                  attend these meetings to stay informed and contribute to
                  discussions.
                </p>
                <div className="overflow-x-auto" data-id="element-4823">
                  <table className="min-w-full bg-white" data-id="element-4824">
                    <thead data-id="element-4825">
                      <tr className="bg-blue-900 text-white" data-id="element-4826">
                        <th className="py-2 px-4 text-left" data-id="element-4827">Meeting Type</th>
                        <th className="py-2 px-4 text-left" data-id="element-4828">Frequency</th>
                        <th className="py-2 px-4 text-left" data-id="element-4829">Typical Agenda</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200" data-id="element-4830">
                      <tr data-id="element-4831">
                        <td className="py-2 px-4 font-medium" data-id="element-4832">
                          General Assembly
                        </td>
                        <td className="py-2 px-4" data-id="element-4833">Once per term</td>
                        <td className="py-2 px-4" data-id="element-4834">
                          School updates, financial reports, major initiatives
                        </td>
                      </tr>
                      <tr className="bg-gray-50" data-id="element-4835">
                        <td className="py-2 px-4 font-medium" data-id="element-4836">
                          Executive Committee
                        </td>
                        <td className="py-2 px-4" data-id="element-4837">Monthly</td>
                        <td className="py-2 px-4" data-id="element-4838">
                          Planning, budget reviews, issue resolution
                        </td>
                      </tr>
                      <tr data-id="element-4839">
                        <td className="py-2 px-4 font-medium" data-id="element-4840">
                          Class Representatives
                        </td>
                        <td className="py-2 px-4" data-id="element-4841">Bi-monthly</td>
                        <td className="py-2 px-4" data-id="element-4842">
                          Class-specific concerns, event coordination
                        </td>
                      </tr>
                      <tr className="bg-gray-50" data-id="element-4843">
                        <td className="py-2 px-4 font-medium" data-id="element-4844">
                          Annual General Meeting
                        </td>
                        <td className="py-2 px-4" data-id="element-4845">Once per year</td>
                        <td className="py-2 px-4" data-id="element-4846">
                          Annual reports, elections, strategic planning
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div data-id="element-4847">
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-4848">
                Upcoming Events
              </h3>
              <div className="space-y-4" data-id="element-4849">
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-4850">
                  <div className="flex" data-id="element-4851">
                    <div className="mr-4" data-id="element-4852">
                      <div className="bg-blue-100 text-blue-900 font-bold rounded p-3 text-center min-w-[70px]" data-id="element-4853">
                        <div className="text-lg" data-id="element-4854">15</div>
                        <div className="text-xs" data-id="element-4855">OCT</div>
                      </div>
                    </div>
                    <div data-id="element-4856">
                      <h4 className="font-bold text-blue-900 mb-1" data-id="element-4857">
                        First Term General Meeting
                      </h4>
                      <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-4858">
                        <ClockIcon className="h-4 w-4 mr-1" data-id="element-4859" />
                        <span data-id="element-4860">3:00 PM - 5:00 PM</span>
                        <span className="mx-2" data-id="element-4861">•</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4862">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-4863" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-4864" />
                        </svg>
                        <span data-id="element-4865">School Auditorium</span>
                      </div>
                      <p className="text-gray-700 text-sm" data-id="element-4866">
                        Welcome address, introduction of new parents,
                        presentation of first term activities, and budget
                        approval.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-4867">
                  <div className="flex" data-id="element-4868">
                    <div className="mr-4" data-id="element-4869">
                      <div className="bg-blue-100 text-blue-900 font-bold rounded p-3 text-center min-w-[70px]" data-id="element-4870">
                        <div className="text-lg" data-id="element-4871">05</div>
                        <div className="text-xs" data-id="element-4872">NOV</div>
                      </div>
                    </div>
                    <div data-id="element-4873">
                      <h4 className="font-bold text-blue-900 mb-1" data-id="element-4874">
                        Career Day
                      </h4>
                      <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-4875">
                        <ClockIcon className="h-4 w-4 mr-1" data-id="element-4876" />
                        <span data-id="element-4877">9:00 AM - 2:00 PM</span>
                        <span className="mx-2" data-id="element-4878">•</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4879">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-4880" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-4881" />
                        </svg>
                        <span data-id="element-4882">School Hall</span>
                      </div>
                      <p className="text-gray-700 text-sm" data-id="element-4883">
                        Parent professionals from various fields will share
                        insights about their careers with students. Volunteer
                        speakers needed!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-4884">
                  <div className="flex" data-id="element-4885">
                    <div className="mr-4" data-id="element-4886">
                      <div className="bg-blue-100 text-blue-900 font-bold rounded p-3 text-center min-w-[70px]" data-id="element-4887">
                        <div className="text-lg" data-id="element-4888">18</div>
                        <div className="text-xs" data-id="element-4889">NOV</div>
                      </div>
                    </div>
                    <div data-id="element-4890">
                      <h4 className="font-bold text-blue-900 mb-1" data-id="element-4891">
                        PTA Fundraising Dinner
                      </h4>
                      <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-4892">
                        <ClockIcon className="h-4 w-4 mr-1" data-id="element-4893" />
                        <span data-id="element-4894">6:00 PM - 9:00 PM</span>
                        <span className="mx-2" data-id="element-4895">•</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4896">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-4897" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-4898" />
                        </svg>
                        <span data-id="element-4899">Golden Tulip Hotel</span>
                      </div>
                      <p className="text-gray-700 text-sm" data-id="element-4900">
                        Annual fundraising dinner to support the Infrastructure
                        Development Project. Tickets available from class
                        representatives.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-4901">
                  <div className="flex" data-id="element-4902">
                    <div className="mr-4" data-id="element-4903">
                      <div className="bg-blue-100 text-blue-900 font-bold rounded p-3 text-center min-w-[70px]" data-id="element-4904">
                        <div className="text-lg" data-id="element-4905">09</div>
                        <div className="text-xs" data-id="element-4906">DEC</div>
                      </div>
                    </div>
                    <div data-id="element-4907">
                      <h4 className="font-bold text-blue-900 mb-1" data-id="element-4908">
                        End of Term Family Fun Day
                      </h4>
                      <div className="flex items-center text-gray-600 text-sm mb-2" data-id="element-4909">
                        <ClockIcon className="h-4 w-4 mr-1" data-id="element-4910" />
                        <span data-id="element-4911">10:00 AM - 4:00 PM</span>
                        <span className="mx-2" data-id="element-4912">•</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4913">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-4914" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-4915" />
                        </svg>
                        <span data-id="element-4916">School Sports Ground</span>
                      </div>
                      <p className="text-gray-700 text-sm" data-id="element-4917">
                        A day of games, food, and entertainment for the entire
                        school community. Volunteers needed for various roles.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* FAQ Section */}
        <section className="mb-16" data-id="element-4918">
          <div className="text-center mb-10" data-id="element-4919">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-4920">
              Frequently Asked Questions
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-4921"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-4922">
              Common questions about the PTA and parent involvement at IGS.
            </p>
          </div>
          <div className="max-w-3xl mx-auto" data-id="element-4923">
            <Accordion variant="bordered" data-id="element-4924">
              <AccordionItem title="How can I join the PTA?" defaultOpen data-id="element-4925">
                <p className="text-gray-700 mb-4" data-id="element-4926">
                  All parents and guardians of current IGS students, as well as
                  all teaching staff, are automatically members of the PTA.
                  There is no formal registration process required to join.
                </p>
                <p className="text-gray-700 mb-4" data-id="element-4927">
                  To become an active member, simply:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 mt-2" data-id="element-4928">
                  <li data-id="element-4929">Attend PTA meetings</li>
                  <li data-id="element-4930">Volunteer for PTA activities and events</li>
                  <li data-id="element-4931">Contribute to PTA initiatives</li>
                  <li data-id="element-4932">
                    Consider running for a position on the Executive Committee
                    during elections
                  </li>
                </ul>
              </AccordionItem>
              <AccordionItem title="What is the PTA fee and how is it used?" data-id="element-4933">
                <p className="text-gray-700 mb-4" data-id="element-4934">
                  The annual PTA fee is ₦5,000 per family, regardless of the
                  number of children enrolled at IGS. This fee is included in
                  the school fees and is collected at the beginning of each
                  academic year.
                </p>
                <p className="text-gray-700 mb-4" data-id="element-4935">
                  The PTA fee is used to fund various initiatives and
                  activities, including:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-4936">
                  <li data-id="element-4937">Infrastructure development and maintenance projects</li>
                  <li data-id="element-4938">Educational resources and equipment</li>
                  <li data-id="element-4939">Student welfare programs</li>
                  <li data-id="element-4940">Teacher appreciation events</li>
                  <li data-id="element-4941">PTA-sponsored scholarships</li>
                  <li data-id="element-4942">Administrative costs of running the PTA</li>
                </ul>
                <p className="mt-4 text-gray-700" data-id="element-4943">
                  A detailed financial report is presented at each general
                  meeting and at the Annual General Meeting.
                </p>
              </AccordionItem>
              <AccordionItem title="How can I volunteer for PTA activities?" data-id="element-4944">
                <p className="text-gray-700 mb-4" data-id="element-4945">
                  There are many ways to volunteer with the PTA, depending on
                  your interests, skills, and availability. Some volunteer
                  opportunities include:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-4946">
                  <li data-id="element-4947">
                    Serving on committees (e.g., Fundraising, Events, Academic
                    Support)
                  </li>
                  <li data-id="element-4948">Helping organize and run events</li>
                  <li data-id="element-4949">
                    Providing professional expertise for specific projects
                  </li>
                  <li data-id="element-4950">Mentoring students in your area of expertise</li>
                  <li data-id="element-4951">Assisting with communication and publicity</li>
                </ul>
                <p className="mt-4 text-gray-700" data-id="element-4952">To volunteer, you can:</p>
                <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-4953">
                  <li data-id="element-4954">Speak to any Executive Committee member</li>
                  <li data-id="element-4955">
                    Email{' '}
                    <span className="text-blue-700" data-id="element-4956">
                      pta@isonyingrammarschool.edu.ng
                    </span>
                  </li>
                  <li data-id="element-4957">
                    Fill out the volunteer form available at the school office
                  </li>
                  <li data-id="element-4958">Sign up during PTA meetings</li>
                </ul>
              </AccordionItem>
              <AccordionItem title="How are PTA Executive Committee members elected?" data-id="element-4959">
                <p className="text-gray-700 mb-4" data-id="element-4960">
                  The PTA Executive Committee is elected every two years at the
                  Annual General Meeting, typically held at the end of the third
                  term. The election process is as follows:
                </p>
                <ol className="list-decimal list-inside space-y-2 text-gray-700" data-id="element-4961">
                  <li data-id="element-4962">Nominations are opened one month before the AGM</li>
                  <li data-id="element-4963">
                    Interested candidates submit their nominations for specific
                    positions
                  </li>
                  <li data-id="element-4964">Candidates may give brief speeches at the AGM</li>
                  <li data-id="element-4965">
                    Elections are conducted by secret ballot during the AGM
                  </li>
                  <li data-id="element-4966">
                    Results are announced and new officers are inaugurated
                  </li>
                </ol>
                <p className="mt-4 text-gray-700" data-id="element-4967">
                  To be eligible for election, a candidate must:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-4968">
                  <li data-id="element-4969">
                    Be a parent/guardian of a current IGS student or a teacher
                    at IGS
                  </li>
                  <li data-id="element-4970">
                    Have been an active PTA member for at least one academic
                    year
                  </li>
                  <li data-id="element-4971">Be nominated and seconded by current PTA members</li>
                </ul>
              </AccordionItem>
              <AccordionItem title="How does the PTA communicate with parents?" data-id="element-4972">
                <p className="text-gray-700 mb-4" data-id="element-4973">
                  The PTA uses multiple channels to communicate with parents and
                  ensure everyone stays informed:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-4974">
                  <li data-id="element-4975">Email newsletters sent monthly</li>
                  <li data-id="element-4976">
                    WhatsApp groups for each class, managed by class
                    representatives
                  </li>
                  <li data-id="element-4977">
                    Notices on the school's physical and digital notice boards
                  </li>
                  <li data-id="element-4978">
                    Letters sent home with students for important announcements
                  </li>
                  <li data-id="element-4979">SMS alerts for urgent information</li>
                  <li data-id="element-4980">Updates during PTA meetings</li>
                  <li data-id="element-4981">Dedicated section on the school website</li>
                </ul>
                <p className="mt-4 text-gray-700" data-id="element-4982">
                  To ensure you receive all communications, please make sure
                  your contact information is up to date with both the school
                  office and your class representative.
                </p>
              </AccordionItem>
            </Accordion>
          </div>
        </section>
        {/* Get Involved Section */}
        <section data-id="element-4983">
          <div className="bg-blue-900 text-white rounded-lg overflow-hidden" data-id="element-4984">
            <div className="container mx-auto px-4 py-12" data-id="element-4985">
              <div className="text-center mb-8" data-id="element-4986">
                <h2 className="text-3xl font-bold mb-4" data-id="element-4987">Get Involved</h2>
                <p className="max-w-2xl mx-auto" data-id="element-4988">
                  Your involvement makes a difference! Join us in creating the
                  best possible educational environment for our children.
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-4989">
                <div className="bg-blue-800/50 p-6 rounded-lg backdrop-blur-sm border border-blue-700/50" data-id="element-4990">
                  <div className="flex items-center mb-4" data-id="element-4991">
                    <div className="p-3 bg-blue-700/50 rounded-full mr-3" data-id="element-4992">
                      <CalendarIcon className="h-6 w-6 text-yellow-400" data-id="element-4993" />
                    </div>
                    <h3 className="text-xl font-bold" data-id="element-4994">Attend Meetings</h3>
                  </div>
                  <p className="mb-4" data-id="element-4995">
                    Stay informed and contribute to discussions by attending
                    regular PTA meetings.
                  </p>
                  <Button href="/pta/calendar" variant="outline" size="sm" className="border-white text-white hover:bg-white/10" data-id="element-4996">
                    View Meeting Schedule
                  </Button>
                </div>
                <div className="bg-blue-800/50 p-6 rounded-lg backdrop-blur-sm border border-blue-700/50" data-id="element-4997">
                  <div className="flex items-center mb-4" data-id="element-4998">
                    <div className="p-3 bg-blue-700/50 rounded-full mr-3" data-id="element-4999">
                      <HandIcon className="h-6 w-6 text-yellow-400" data-id="element-5000" />
                    </div>
                    <h3 className="text-xl font-bold" data-id="element-5001">Volunteer</h3>
                  </div>
                  <p className="mb-4" data-id="element-5002">
                    Share your time and talents to support school activities and
                    PTA initiatives.
                  </p>
                  <Button href="/pta/volunteer" variant="outline" size="sm" className="border-white text-white hover:bg-white/10" data-id="element-5003">
                    Volunteer Opportunities
                  </Button>
                </div>
                <div className="bg-blue-800/50 p-6 rounded-lg backdrop-blur-sm border border-blue-700/50" data-id="element-5004">
                  <div className="flex items-center mb-4" data-id="element-5005">
                    <div className="p-3 bg-blue-700/50 rounded-full mr-3" data-id="element-5006">
                      <HeartIcon className="h-6 w-6 text-yellow-400" data-id="element-5007" />
                    </div>
                    <h3 className="text-xl font-bold" data-id="element-5008">Donate</h3>
                  </div>
                  <p className="mb-4" data-id="element-5009">
                    Support our projects through financial contributions or
                    in-kind donations.
                  </p>
                  <Button href="/pta/donate" variant="outline" size="sm" className="border-white text-white hover:bg-white/10" data-id="element-5010">
                    Support Our Initiatives
                  </Button>
                </div>
              </div>
              <div className="text-center" data-id="element-5011">
                <p className="mb-6" data-id="element-5012">
                  Have questions or suggestions? We'd love to hear from you!
                </p>
                <Button href="mailto:pta@isonyingrammarschool.edu.ng" variant="primary" size="lg" data-id="element-5013">
                  Contact the PTA
                </Button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default PTA;